import React from "react";

const ICON_SRC =
  "https://customer-assets.emergentagent.com/job_latam-talent-scale/artifacts/sansch88_revgen-icon-blue.png";

export const LogoMark = ({ className = "" }) => (
  <img
    src={ICON_SRC}
    alt="RevGen"
    width="80"
    height="80"
    decoding="async"
    loading="eager"
    draggable="false"
    className={`object-contain select-none ${className}`}
    style={{ imageRendering: "auto" }}
  />
);

export const Logo = ({ inverted = false }) => (
  <div className="flex items-center gap-2.5">
    <LogoMark className="h-10 w-10 rounded-lg shrink-0" />
    <span
      className={`text-[26px] leading-none font-extrabold tracking-tight ${
        inverted ? "text-white" : "text-[#0A1628]"
      }`}
    >
      RevGen
    </span>
  </div>
);

export default Logo;
